export const TARIFS_ANNUEL = {
  PEI_OR_PERCOLI: {
    ENTREPRISE: '118',
    BENEFICIAIRE: '18'
  },
  PEI_AND_PERCOLI: {
    ENTREPRISE: '171',
    BENEFICIAIRE: '22'
  }
}